'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _debugActions = require('./debugActions');

var _debugUtil = require('./debugUtil');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Actions


// Utils


var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        enableDebugFeatures: function enableDebugFeatures() {
            return dispatch((0, _debugActions.enableDebugTools)());
        }
    };
};

exports.default = function (DecoratedComponent) {
    var _dec, _class;

    var DebugManagerDecorator = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
        _inherits(DebugManagerDecorator, _React$Component);

        function DebugManagerDecorator() {
            _classCallCheck(this, DebugManagerDecorator);

            var _this = _possibleConstructorReturn(this, (DebugManagerDecorator.__proto__ || Object.getPrototypeOf(DebugManagerDecorator)).call(this));

            window.enableDebug = _this.enableDebugFeatures.bind(_this);
            return _this;
        }

        _createClass(DebugManagerDecorator, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                if ((0, _debugUtil.shouldEnableDebugFeatures)()) {
                    console.info('Milanote debug tools enabled');
                    this.enableDebugFeatures();
                }
            }
        }, {
            key: 'enableDebugFeatures',
            value: function enableDebugFeatures() {
                this.props.enableDebugFeatures();
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(DecoratedComponent, this.props);
            }
        }]);

        return DebugManagerDecorator;
    }(_react2.default.Component)) || _class);


    DebugManagerDecorator.propTypes = {
        enableDebugFeatures: _propTypes2.default.func
    };

    return DebugManagerDecorator;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/debug/debugManagerDecorator.js
// module id = 1938
// module chunks = 0